import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/* ---------- Reclamos (casework) ---------- */

export async function listCasework(params = {}) {
  const { data } = await client.get('/casework', { params });
  return data.casework || [];
}

export async function createCasework(payload) {
  const { data } = await client.post('/casework', payload);
  return data.casework;
}

export async function updateCasework(id, payload) {
  const { data } = await client.patch(`/casework/${id}`, payload);
  return data.casework;
}

export async function deleteCasework(id) {
  await client.delete(`/casework/${id}`);
}

export async function getCasework(id) {
  const { data } = await client.get(`/casework/${id}`);
  return data;
}

export async function addCaseworkEvent(id, payload) {
  const { data } = await client.post(`/casework/${id}/events`, payload);
  return data.event;
}

export async function makeContentFromCasework(id, payload = {}) {
  const { data } = await client.post(`/casework/${id}/make-content`, payload);
  return data.material;
}

/* ---------- Barrios / territorio ---------- */

export async function listBarrios() {
  const { data } = await client.get('/territory/barrios');
  return data.barrios || [];
}

export async function getCoverage() {
  const { data } = await client.get('/territory/coverage');
  return data;
}

export async function listVisits(params = {}) {
  const { data } = await client.get('/territory/visits', { params });
  return data.visits || [];
}

export async function createVisit(payload) {
  const { data } = await client.post('/territory/visits', payload);
  return data.visit;
}

export async function setBarrioCoords(id, lat, lng) {
  const { data } = await client.patch('/territory/barrios', { id, lat, lng });
  return data.barrio;
}

export async function clearBarrioCoords(id) {
  const { data } = await client.patch('/territory/barrios', { id, clear: true });
  return data.barrio;
}

export async function getBarrioDetalle(id) {
  const { data } = await client.get('/territory/barrio', { params: { id } });
  return data;
}
